import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './not_found.module.css';

const NotFoundView: React.FC = ({}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname !== '/404' || location.search) {
      navigate({ pathname: '/404', search: '' }, { replace: true });
    }
  }, [location.pathname, location.search, navigate]);

  return (
    <div className={styles.notFound}>
      <div className={styles.inner}>
        <div className={styles.message}>
          <p>{t('error.notFoundTitle')}</p>
          <p>{t('error.notFoundDescription')}</p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundView;
